<div [class]="needsNewPassword ? 'loading-bg wrapper' : 'wrapper'">
    <div *ngIf="needsNewPassword" class="content">
        <password
            [onPasswordValid]="handlePasswordValid"
            [onPasswordInvalid]="handlePasswordInvalid"
            [showTitle]="true"
            title="Create a Password"
            subTitle="Please create a password to complete your account set up and enable you to log back into the application in the future."
            [showRequirements]="true"
            [hideConfirmPassword]="false"
            [requirementsAboveFields]="false"
        ></password>

        <div>
            <p>If you have any questions or need help, please reach out to us.</p>

            <div class="support-wrap">
                <p><b>EZ DOCS Support</b></p>
                <p>Phone: {{ tenantSupportPhone }}</p>
                <p>Email: {{ tenantSupportEmail }}</p>
                <p><em>Our support team is available Monday through Friday from 8am to 8pm and Saturdays from 10am to 6pm (all times Eastern).</em></p>
            </div>
        </div>

        <div class="btn-wrap">
            <button mat-button class="secondary" (click)="cancel()">Cancel</button>
            <button mat-button class="primary" [disabled]="!formValid()" (click)="enroll()">Save and Continue</button>
        </div>
    </div>
</div>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>
